import { render, staticRenderFns } from "./FormCollection.vue?vue&type=template&id=7e078a50&"
import script from "./FormCollection.vue?vue&type=script&lang=js&"
export * from "./FormCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports